import helper from "@/utils/helper";
import cookie from "@/utils/cookie";

const kcolor = cookie.read("voox_kcolor") || 0;
const green = {
  main: "#00BC9B",
  50: "#80DECD",
  20: "#CCF2EB",
  m50: "#005E4D",
  m20: "#00261F",
  hover: "#EB2F7F",
  light: "#00BC9B",
  dark: "#00BC9B",
  contrastText: "#fff",
};
const red = {
  main: "#EB2F7F",
  50: "#F597BF",
  20: "#FBD5E5",
  m50: "#75173F",
  m20: "#460E26",
  hover: "#EB2F7F",
  contrastText: "#fff",
  light: "#EB2F7F",
  dark: "#EB2F7F",
};
const blue = {
  main: "#3472EB",
  50: "#99b8f5",
  20: "#d6e3fb",
  m50: "#1a3976",
  m20: "#102247",
  hover: "#d6e3fb",
  contrastText: "#fff",
  light: "#d6e3fb",
  dark: "#d6e3fb",
};
const _palette = {
  common: {
    black: "#000000",
    text: "#111219",
    surface: "#fff",
    white: "#fff",
    background: "#fff",
  },
  mode: "light",
  commonBg: "#FFFFFF",
  primary: {
    main: "#863DFF",
    50: "#C29EFF",
    20: "#E7D8FF",
    m50: "#502599",
    m20: "#28124C",
    hover: "#863DFF",
    contrastText: "#fff",
    light: "#863DFF",
    dark: "#863DFF",
  },
  support: {
    main: "#28E7C5",
    50: "#93F3E2",
    20: "#D4FAF3",
    m50: "#147362",
    m20: "#082E27",
    hover: "#28E7C5",
    contrastText: "#111219",
    light: "#28E7C5",
    dark: "#28E7C5",
  },
  secondary: {
    main: "#FF9C40",
    50: "#FFCDA0",
    20: "#FFEBD9",
    m50: "#804E20",
    m20: "#331F0D",
    hover: "#FF9C40",
    contrastText: "#111219",
    light: "#FF9C40",
    dark: "#FF9C40",
  },
  error: {
    main: "#EB2F7F",
    50: "#F597BF",
    20: "#FBD5E5",
    m50: "#75173F",
    m20: "#460E26",
    hover: "#EB2F7F",
    contrastText: "#fff",
    light: "#EB2F7F",
    dark: "#EB2F7F",
  },
  success: {
    main: "#00BC9B",
    50: "#80DECD",
    20: "#CCF2EB",
    m50: "#005E4D",
    m20: "#00261F",
    hover: "#EB2F7F",
    light: "#00BC9B",
    dark: "#00BC9B",
    contrastText: "#fff",
  },
  // 同 secondary
  warning: {
    main: "#FF9C40",
    50: "#FFCDA0",
    20: "#FFEBD9",
    m50: "#804E20",
    m20: "#331F0D",
    hover: "#FF9C40",
    contrastText: "#111219",
    light: "#FF9C40",
    dark: "#FF9C40",
  },
  // 同 success
  info: {
    main: "#00BC9B",
    50: "#80DECD",
    20: "#CCF2EB",
    m50: "#005E4D",
    m20: "#00261F",
    hover: "#EB2F7F",
    light: "#00BC9B",
    dark: "#00BC9B",
    contrastText: "#fff",
  },
  grey: {
    white: "#fff",
    black: "#000",
    5: "#F3F3F3",
    10: "#E7E7E7",
    25: "#C3C3C3",
    50: "#878787",
    m10: "#282828",
    m15: "#343434",
    m25: "#4C4C4C",
    m40: "#707070",
  },
  text: {
    primary: "#111219",
    5: "#F2F6F9",
    15: "#DBDCE0",
    25: "#BCBDC3",
    60: "#67686D",
    100: "#111219",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,

  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: "#fff",
    default: "#fff",
    400: "rgba(50, 51, 64, 0.96)",
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(107, 109, 131, 0.1)",
    hoverOpacity: 0.08,
    selected: "rgba(0, 0, 0, 0.14)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
};
const _palette_dark = {
  mode: "dark",
  commonBg: "#0B0C0E",
  primary: {
    main: "#863DFF",
    50: "#4D2889",
    20: "#2A1B42",
    m50: "#AA77FF",
    m20: "#CFB1FF",
    hover: "#863DFF",
    contrastText: "#fff",
    light: "#863DFF",
    dark: "#863DFF",
  },
  support: {
    main: "#28E7C5",
    50: "#1E7D6C",
    20: "#173D37",
    m50: "#93F3E2",
    m20: "#D4FAF3",
    hover: "#28E7C5",
    contrastText: "#111219",
    light: "#28E7C5",
    dark: "#28E7C5",
  },
  secondary: {
    main: "#FF9C40",
    50: "#89572A",
    20: "#422E1C",
    m50: "#FFCDA0",
    m20: "#FFEBD9",
    hover: "#FF9C40",
    contrastText: "#111219",
    light: "#FF9C40",
    dark: "#FF9C40",
  },
  error: {
    main: "#EB2F7F",
    50: "#8C2E5A",
    20: "#5D2E48",
    m50: "#F597BF",
    m20: "#FBD5E5",
    hover: "#EB2F7F",
    contrastText: "#fff",
    light: "#EB2F7F",
    dark: "#EB2F7F",
  },
  success: {
    main: "#00BC9B",
    50: "#177568",
    20: "#22514E",
    m50: "#80DECD",
    m20: "#CCF2EB",
    hover: "#00BC9B",
    light: "#00BC9B",
    dark: "#00BC9B",
    contrastText: "#fff",
  },
  // 同 secondary
  warning: {
    main: "#FF9C40",
    50: "#89572A",
    20: "#422E1C",
    m50: "#FFCDA0",
    m20: "#FFEBD9",
    hover: "#FF9C40",
    contrastText: "#111219",
    light: "#FF9C40",
    dark: "#FF9C40",
  },
  // 同 success
  info: {
    main: "#00BC9B",
    50: "#177568",
    20: "#22514E",
    m50: "#80DECD",
    m20: "#CCF2EB",
    hover: "#00BC9B",
    light: "#00BC9B",
    dark: "#00BC9B",
    contrastText: "#fff",
  },
  grey: {
    white: "#111",
    black: "#fff",
    5: "#202121",
    10: "#292A2A",
    25: "#4B4C4D",
    50: "#828486",
    m10: "#DCDFE2",
    m15: "#AFB2B4",
    m25: "#8E9091",
    m40: "#6C6E6F",
  },
  text: {
    primary: "#F2F6F9",
    5: "#2D2D35",
    15: "#404041",
    25: "#6C6E6F",
    60: "#999B9D",
    100: "#F2F6F9",
  },
};
const themeFn = (mode) => {
  let palette = mode == "dark" ? _palette_dark : _palette;
  // 0: 绿涨红跌 1: 红涨绿跌 2: 红涨蓝跌
  if (kcolor == 0) {
    palette.success = green;
    palette.error = red;
  }
  if (kcolor == 1) {
    palette.success = red;
    palette.error = green;
  }
  if (kcolor == 2) {
    palette.success = red;
    palette.error = blue;
  }
  return {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "initial",
            fontSize: 14,
            fontFeatureSettings: "'clig' off, 'liga' off",
            "&:hover": {},
          },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            boxShadow: "0px 7px 12.4px 0px #0000001F",
            borderRadius: 8,
            padding: 0,
          },
        },
      },
    },
    palette,
  };
};

export default themeFn;
